// external dependencies
import { object } from 'prop-types'
import React, { useLayoutEffect } from 'react'
import { graphql } from 'gatsby'
import { ThemeProvider } from 'emotion-theming'

import { init as esInit } from '@bizdotcom/event-stream-pixel'
import RfqProvider from '@duplo/components/lib/RfqProvider'
import TrackingWrapper from '@duplo/components/lib/TrackingWrapper'
import GlobalWidgetStyles from '@duplo/components/lib/GlobalWidgetStyles'
import SpinnerOverlay from '@duplo/components/lib/SpinnerOverlay'
import useDynamicThemeLoader from '@duplo/components/lib/hooks/useDynamicThemeLoader'
import { isBrowser } from '@duplo/utils/lib/browser'

// graphql fragment
import { qsData } from 'constants/graphqlQueries' // eslint-disable-line no-unused-vars

import Layout from 'components/layout'

// relative components
import View from './View'

WidgetTemplate.propTypes = {
	data: object,
	pageContext: object,
}

function WidgetTemplate(props) {
	//eslint-disable-next-line react-hooks/rules-of-hooks
	const theme = isBrowser() && useDynamicThemeLoader('widget')

	/* using useLayoutEffect hook here because i need this to happen BEFORE anything renders so that by the time
	any tracking calls are made the pixel is definitley intialized!  for more info on the difference between
	and useLayoutEffect see here: https://reactjs.org/docs/hooks-reference.html#uselayouteffect */
	useLayoutEffect(() => {
		// Initialize the Event Stream pixel
		esInit({ stage: process.env.GATSBY_ES_STAGE })
	}, [])

	return (
		<Layout>
			{theme && (
				<ThemeProvider theme={theme}>
					<GlobalWidgetStyles />

					<RfqProvider
						categoryData={props.data.bzCategory}
						orchId={props.pageContext.orchId}
						pageContext={props.pageContext}
					>
						<TrackingWrapper>
							<View />
						</TrackingWrapper>
					</RfqProvider>
				</ThemeProvider>
			)}
			{!theme && <SpinnerOverlay />}
		</Layout>
	)
}

export default WidgetTemplate

export const pageQuery = graphql`
	query widgetCategoryQuery($id: String!) {
		bzCategory(id: { eq: $id }) {
			altImage1
			categoryId
			categoryName
			contentPath
			productIcon
			productImage
			...qsData
		}
	}
`
